import React from "react";

// This is a placeholder component that will be updated later with actual error handling logic
const ErrorNotification: React.FC = () => {
  // Simplified version that doesn't do anything yet
  return null;
};

export default ErrorNotification;
